import ScrollClass from './../../../js/classes/Scroll.js'
import './../popups/react/order-call/component.jsx'

document.querySelector('.scroll-arrow').addEventListener('click', () => {
    ScrollClass.scrollTo('.header', 300)
})

//Menu toggle
const footerTabletMenuButton = document.querySelector('.footer__mobile-menu'),
pageBodyHeaderContainer = document.querySelector('.page__body-header')

if (footerTabletMenuButton && pageBodyHeaderContainer) {
    const handleToggle = () => {
        ScrollClass.scrollTo(pageBodyHeaderContainer, 100)
        pageBodyHeaderContainer.classList.add('page__body-header_show')
    }

    footerTabletMenuButton.addEventListener('click', handleToggle)
}

//Select shops
const selectShops = document.querySelector('#footer-select-shops')

if (selectShops) {
    selectShops.addEventListener('change', () => {
        if (selectShops.value !== 'NULL') {
            document.location = '/about/#nailbrand-shops'
        }
    })
}